import React, { useEffect, useState } from "react";
import { formatApiError } from "./formatApiError";
import "./appToast.css";

var listeners = [];
var seq = 0;

export function showToast(message, kind) {
  var text = formatApiError(message);
  if (!text) return;
  var item = {
    id: ++seq,
    message: text,
    kind: kind === "success" || kind === "info" ? kind : "error",
  };
  listeners.forEach(function (fn) {
    try {
      fn(item);
    } catch (e) {
      /* ignore */
    }
  });
}

export function showSuccessToast(message) {
  showToast(message, "success");
}

export function AppToastHost() {
  var _items = useState([]);
  var items = _items[0];
  var setItems = _items[1];

  useEffect(function () {
    var onToast = function (item) {
      setItems(function (prev) {
        return prev.concat([item]).slice(-4);
      });
      window.setTimeout(function () {
        setItems(function (prev) {
          return prev.filter(function (row) {
            return row.id !== item.id;
          });
        });
      }, item.kind === "error" ? 6500 : 4200);
    };
    listeners.push(onToast);
    return function () {
      listeners = listeners.filter(function (fn) {
        return fn !== onToast;
      });
    };
  }, []);

  if (!items.length) return null;
  return React.createElement(
    "div",
    { className: "app-toast-host", role: "status", "aria-live": "polite" },
    items.map(function (row) {
      return React.createElement(
        "div",
        {
          key: row.id,
          className: "app-toast app-toast--" + row.kind,
          role: row.kind === "error" ? "alert" : "status",
        },
        React.createElement("span", { className: "app-toast__mark", "aria-hidden": "true" }, row.kind === "success" ? "✓" : row.kind === "info" ? "i" : "!"),
        React.createElement("span", { className: "app-toast__text" }, row.message),
        React.createElement(
          "button",
          {
            type: "button",
            className: "app-toast__close",
            "aria-label": "Dismiss",
            onClick: function () {
              setItems(function (prev) {
                return prev.filter(function (x) {
                  return x.id !== row.id;
                });
              });
            },
          },
          "×"
        )
      );
    })
  );
}
